import React, {Component} from 'react';
import {
    DialogTitle,
    Flex,
    Text,
    PriorityIcon,
    CheckBox,
    Button,
    Icon,
    Link,
    HTMLDialog,
    CounterInput
} from '@priority-software/priority-style-react';
import styles from '../styles/printDialog.module.scss';
import TypeCard from '../../../components/Common/ActionCard/ActionCard';
import texts, {getServerTexts} from '../texts';
import {isValid} from '@priority-software/priority-utils/lib/number';
import FormatsDropdown from './FormatsDropdown';
import {actionTypes, mapActionToMode, actionTypeProps, mapModeToAction} from '../consts/printTypes';
import {showHelpMessage} from '../../../_shared/Messages/actions/MessageActions';
import messageText from '../../../_shared/Messages/texts';
import {keyCodes} from '../../../constants';
import {
    executePrint,
    openDesignReportPanel,
    cancleProcedure
} from '../../../_shared/GWTBridge/invoke/procedures';
import {setIsNavigationEnabled} from '../../../_shared/GWTBridge/invoke/genPage';
import {getUserChoicesLocalStorage, setPrintDefsLocalStorage} from '../actions/printDialog';
import {
    getTopDialogZindex,
    updateTopDialogZindex
} from '../../../_shared/GWTBridge/invoke/priModalDlg';
import {EntityType} from '../../../constants/EntityTypes';
import {isPluginDisabled, showOnNoPluginMessage} from '../../../_shared/GWTBridge/invoke/common';
import {Label} from '../../../components/Common/Label';

interface PrintDialogState {
    selectedType: actionTypes;
    isOpen: boolean;
    isOnBackground: boolean;
    copies: string;
    isQuickPrint: boolean;
    isAttachments: boolean;
    isPdf: boolean;
    actionTypeProps: {
        isQuickPrintEnabled: boolean;
        isAttachmentEnabled: boolean;
        isPdfEnabled: boolean;
    };
    selectedFormat: any;
    hasMail: boolean;
    title: string;
    entityType?: EntityType;
    wordTemplates: any[];
    formats: any[];
    isword: boolean;
    isFormatSelected: boolean;
    ename: string;
    showdesign: boolean;
    printorig: boolean;
    isEnglishHTML: boolean;
}

const printDlgRef: React.RefObject<PrintDialog> = React.createRef();

export async function renderPrintDialog(root) {
    await getServerTexts();
    root.render(<PrintDialog ref={printDlgRef} />);
    return printDlgRef;
}

const printDialogID = 'priority-print-dialog';

export class PrintDialog extends Component<{}, PrintDialogState> {
    isPluginDisabled = isPluginDisabled();
    actionProps = actionTypeProps(this.isPluginDisabled);

    defaultState = {
        isOpen: false,
        isOnBackground: false,
        selectedType: actionTypes.PRINT,
        actionTypeProps: {
            ...this.actionProps[actionTypes.PRINT]
        },
        copies: '1',
        isQuickPrint: false,
        isAttachments: false,
        isPdf: false,
        selectedFormat: undefined,
        hasMail: true,
        title: '',
        entityType: undefined,
        wordTemplates: [],
        formats: [],
        isword: false,
        isFormatSelected: false,
        ename: '',
        showdesign: false,
        printorig: false,
        isEnglishHTML: false
    };
    state = {
        ...this.defaultState
    };

    handleKeyDown = e => {
        if (e.keyCode === keyCodes.ENTER && this.state.isFormatSelected) {
            this.handleAplly();
        } else if (e.keyCode === keyCodes.ESC) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.closeDialog();
        }
    };
    init = () => {
        this.setState({
            ...this.defaultState
        });
    };

    closeDialog = (isCancleProcedure = true) => {
        this.init();
        window.removeEventListener('keydown', this.handleKeyDown, true);
        setIsNavigationEnabled(true);
        updateTopDialogZindex(false);
        isCancleProcedure && cancleProcedure();
    };

    hanldeTypeClick = typeProps => {
        this.setState({
            ...typeProps
        });
    };

    handleChangeCopies = value => {
        if (isValid(value, 0, 4, true)) {
            this.setState({copies: value});
        }
    };

    handleToggleQuickPrint = () => {
        this.setState(({isQuickPrint}) => ({isQuickPrint: !isQuickPrint}));
    };

    handleToggleAttachments = () => {
        this.setState(({isAttachments}) => ({isAttachments: !isAttachments}));
    };

    handleTogglePdf = () => {
        this.setState(({isPdf}) => ({isPdf: !isPdf}));
    };

    saveUserChoicesInLocalStorage = () => {
        const {isPdf, isAttachments, isQuickPrint, copies, ename} = this.state;
        setPrintDefsLocalStorage(ename, {isPdf, isAttachments, isQuickPrint, copies});
    };
    handleAplly = () => {
        this.executePrint();
        this.saveUserChoicesInLocalStorage();
        this.closeDialog(false);
    };

    executePrint = () => {
        const {
            selectedType,
            isAttachments,
            copies,
            isPdf,
            isQuickPrint,
            selectedFormat,
            isword,
            printorig
        } = this.state;
        const action = mapActionToMode[selectedType];

        //In case the plugin is disabled we need to set these options to false, instead of using the last sent value (that could be true)
        //attachment is not allowd on PRINT mode
        let isAttachmentsFix = isAttachments;
        let isQuickPrintFix = isQuickPrint;
        if (this.isPluginDisabled) {
            //PRINT action with word format is not supported without plugin
            if (selectedType === actionTypes.PRINT && isword) {
                showOnNoPluginMessage(messageText.wordPrintNoPluginTitle);
                return;
            }

            isQuickPrintFix = false;
            //check if the selected is Print to disable attachments
            if (selectedType === actionTypes.PRINT) {
                isAttachmentsFix = false;
            }
        }

        let format = -1;
        if (selectedFormat) {
            format = selectedFormat.template ? selectedFormat.template : selectedFormat.format;
        }
        let mode = action;
        //logid taken from gwt - askPrint
        if (action && isword) {
            mode += 10;
        }
        executePrint(mode, format, isAttachmentsFix, copies, isPdf, isQuickPrintFix, printorig);
    };

    getSelectedFormat = (wordTemplates, formats, isword) => {
        if (!wordTemplates.length && !formats.length) {
            return null;
        }
        const arr = isword === '1' ? wordTemplates : formats;
        return arr.find(item => item.selected === '1') || arr[0];
    };

    handleOpen = (
        {
            hasmail,
            WordTemplates = [],
            WordTemplatesForeignLang = [],
            isword,
            Formats,
            modeselected,
            sendattach,
            pdf,
            showdesign
        },
        title,
        entityType,
        ename,
        printorig,
        isEnglishHTML
    ) => {
        window.addEventListener('keydown', this.handleKeyDown, true);
        setIsNavigationEnabled(false);
        updateTopDialogZindex(true);

        const selectedType = mapModeToAction[modeselected] || actionTypes.PRINT;
        const wordTemplates = [...WordTemplates, ...WordTemplatesForeignLang];
        const formats = Formats || [];
        const selectedFormat = this.getSelectedFormat(wordTemplates, formats, isword);
        const {isAttachments, isPdf, isQuickPrint, copies = 1} = getUserChoicesLocalStorage(ename);

        //if there is no values from the local storage get the values from the server
        const isAttachmentsFix = isAttachments == null ? sendattach === '1' : isAttachments;
        const isPdfFix = isPdf == null ? pdf === '1' : isPdf;

        this.setState({
            isOpen: true,
            isOnBackground: false,
            title,
            isQuickPrint,
            isPdf: isPdfFix,
            isAttachments: isAttachmentsFix,
            hasMail: hasmail === '1',
            entityType,
            wordTemplates,
            formats,
            copies,
            isword: isword === '1',
            selectedFormat,
            selectedType,
            printorig,
            actionTypeProps: {
                ...this.actionProps[selectedType]
            },
            isFormatSelected: true,
            ename,
            showdesign: showdesign === '1',
            isEnglishHTML: isEnglishHTML
        });
    };
    //use for gwt ref
    showPrintDlg = (
        ds,
        title,
        entityType: EntityType,
        ename,
        printorig = false,
        isEnglishHTML = false
    ) => {
        const data = ds.Procedure && ds.Procedure[0] && ds.Procedure[0].AskPrint[0];
        data && this.handleOpen(data, title, entityType, ename, printorig, isEnglishHTML);
    };

    moveDialogToForeground = () => {
        if (this.state.isOpen && this.state.isOnBackground) {
            this.setState({isOnBackground: false});
        }
    };

    handleFormatSelect = selectedFormat => {
        const isword = !selectedFormat.format;
        this.setState({selectedFormat, isword, isFormatSelected: true});
    };

    handleHelpClick = () => {
        const content = `${texts.htmlHelp}`;
        showHelpMessage(content);
    };

    handleOpenReportDesign = () => {
        openDesignReportPanel(this.state.isword);
        this.setState({isOnBackground: true});
    };

    toggleIsFormatSelected = isFormatSelected => {
        if (this.state.isFormatSelected !== isFormatSelected) {
            this.setState({isFormatSelected});
        }
    };
    renderFormatOptions = () =>
        !this.state.wordTemplates.length && !this.state.formats.length ? null : (
            <div>
                <Flex justifyContent="space-between" style={{marginBottom: '8px'}}>
                    <Flex alignItems="center" justifyContent="flex-start">
                        <Text textColor="primary-700" skin="paragraph-1">
                            {texts.formatTitle}
                        </Text>
                        <Icon
                            onClick={this.handleHelpClick}
                            componentClasses={styles.titleIcon}
                            icon={PriorityIcon.questionCircle}
                            iconColor="secondary-300"
                        />
                    </Flex>
                    {this.state.showdesign && (
                        <Link
                            componentClasses={styles.showDesingLink}
                            onClick={this.handleOpenReportDesign}
                        >
                            {texts.customize}
                        </Link>
                    )}
                </Flex>
                <FormatsDropdown
                    formatsList={this.state.formats}
                    wordTemplatesList={this.state.wordTemplates}
                    onSelectFormat={this.handleFormatSelect}
                    selectedFormat={this.state.selectedFormat}
                    toggleIsFormatSelected={this.toggleIsFormatSelected}
                    onDropdownClose={this.onFormtasDropdownclose}
                    isEnglishHTML={this.state.isEnglishHTML}
                />
            </div>
        );

    //return focus after formats dropdown close
    //to not lose focus on the dialog after closing the dropdown with ESC key
    applyButtonRef = React.createRef<HTMLButtonElement>();
    onFormtasDropdownclose = () => {
        this.applyButtonRef && this.applyButtonRef.current && this.applyButtonRef.current.focus();
    };

    renderTypeSelect = () => {
        return (
            <div>
                <Label textColor="primary-700" skin="paragraph-1" componentClasses={styles.title}>
                    {texts.typeSelectTitle}
                </Label>

                <Flex justifyContent="flex-start">
                    <TypeCard
                        componentClasses={styles.marginTypeCard}
                        tooltipPortalId={printDialogID}
                        tooltip={texts.printTooltip}
                        icon={PriorityIcon.printThin}
                        title={texts.print}
                        isSelected={this.state.selectedType === actionTypes.PRINT}
                        onClick={() =>
                            this.hanldeTypeClick({
                                selectedType: actionTypes.PRINT,
                                actionTypeProps: {
                                    ...this.actionProps[actionTypes.PRINT]
                                }
                            })
                        }
                    />
                    <TypeCard
                        componentClasses={styles.marginTypeCard}
                        tooltip={texts.showTooltip}
                        tooltipPortalId={printDialogID}
                        icon={PriorityIcon.displayFile}
                        title={texts.show}
                        isSelected={this.state.selectedType === actionTypes.SHOW}
                        onClick={() =>
                            this.hanldeTypeClick({
                                selectedType: actionTypes.SHOW,
                                actionTypeProps: {
                                    ...this.actionProps[actionTypes.SHOW]
                                }
                            })
                        }
                    />
                    <TypeCard
                        componentClasses={styles.marginTypeCard}
                        tooltip={texts.mailTooltip}
                        tooltipPortalId={printDialogID}
                        icon={PriorityIcon.newEmail}
                        title={texts.mail}
                        isSelected={this.state.selectedType === actionTypes.MAIL}
                        onClick={() => {
                            this.hanldeTypeClick({
                                selectedType: actionTypes.MAIL,
                                actionTypeProps: {
                                    ...this.actionProps[actionTypes.MAIL]
                                }
                            });
                        }}
                    />
                    {this.state.hasMail && (
                        <TypeCard
                            componentClasses={styles.marginTypeCard}
                            tooltip={texts.quickMailTooltip}
                            tooltipPortalId={printDialogID}
                            icon={PriorityIcon.quickmail}
                            title={texts.quickMail}
                            isSelected={this.state.selectedType === actionTypes.QUICK_MAIL}
                            onClick={() =>
                                this.hanldeTypeClick({
                                    selectedType: actionTypes.QUICK_MAIL,
                                    actionTypeProps: {
                                        ...this.actionProps[actionTypes.QUICK_MAIL]
                                    }
                                })
                            }
                        />
                    )}
                </Flex>
            </div>
        );
    };

    renderContent = () => {
        return (
            <div className={styles.content}>
                {this.renderFormatOptions()}
                {this.renderTypeSelect()}
            </div>
        );
    };

    renderFooter = () => {
        const {isAttachments, isQuickPrint, isPdf, actionTypeProps, copies, printorig} = this.state;

        const {isAttachmentEnabled, isQuickPrintEnabled, isPdfEnabled} = actionTypeProps;

        return (
            <Flex
                componentClasses={styles.footer}
                justifyContent="space-between"
                direction="column"
            >
                <Flex componentClasses={styles.footerFirstSection} justifyContent="flex-start">
                    {isAttachmentEnabled && (
                        <CheckBox
                            checked={isAttachments}
                            onChange={this.handleToggleAttachments}
                            ariaLabel={texts.attachment}
                        >
                            <Text textColor="primary-700" skin="paragraph-1">
                                {texts.attachment}
                            </Text>
                        </CheckBox>
                    )}
                    {isQuickPrintEnabled && !this.isPluginDisabled && (
                        <CheckBox
                            checked={isQuickPrint}
                            onChange={this.handleToggleQuickPrint}
                            ariaLabel={texts.quickPrint}
                        >
                            <Text textColor="primary-700" skin="paragraph-1">
                                {texts.quickPrint}
                            </Text>
                        </CheckBox>
                    )}
                    {isPdfEnabled && (
                        <CheckBox
                            checked={isPdf}
                            onChange={this.handleTogglePdf}
                            ariaLabel={texts.pdfFile}
                        >
                            <Text textColor="primary-700" skin="paragraph-1">
                                {texts.pdfFile}
                            </Text>
                        </CheckBox>
                    )}
                </Flex>
                {(isQuickPrint || printorig) && isQuickPrintEnabled && (
                    <Flex
                        direction="column"
                        alignItems="flex-start"
                        componentClasses={styles.copiesCounter}
                    >
                        <Text textColor="primary-700" skin="label-1">
                            {texts.copies}
                        </Text>

                        <CounterInput
                            step={1}
                            onChange={this.handleChangeCopies}
                            value={Number(copies)}
                            minValue={1}
                            componentClasses={styles.copiesInput}
                        />
                    </Flex>
                )}
                <Button
                    onClick={this.handleAplly}
                    skin="primary"
                    width="regularFixed"
                    size="large"
                    disabled={!this.state.isFormatSelected}
                    inputRef={this.applyButtonRef}
                    componentClasses={styles.applyButton}
                >
                    {texts.apply}
                </Button>
            </Flex>
        );
    };

    render() {
        const {isOpen, isOnBackground} = this.state;

        return (
            <div className={styles.component}>
                {isOpen && !isOnBackground && (
                    <HTMLDialog
                        id={printDialogID}
                        size="large"
                        isOpen={isOpen}
                        title={
                            <DialogTitle
                                title={this.state.title}
                                skin="h4"
                                textColor="primary-700"
                                icon={
                                    <Icon
                                        icon={PriorityIcon.closeSmall}
                                        iconColor="secondary-500"
                                        onClick={this.closeDialog}
                                    />
                                }
                                componentClasses={styles.dialogTitle}
                            />
                        }
                        width={720}
                        content={this.renderContent()}
                        footer={this.renderFooter()}
                        onClose={this.closeDialog}
                        zIndex={getTopDialogZindex()}
                        componentClasses={styles.dialog}
                        closable={false}
                        escClosable={false}
                        draggable
                    />
                )}
            </div>
        );
    }
}
